import { lazyLoad } from '@/lib/LazyLoad';

export const DashboardPage = lazyLoad(
  () => import('./DashboardPage'),
  (module) => module.DashboardPage
);
